import React from "react";

interface Props {
  label: string;
  badge?: string;
  hint?: string;
  children: React.ReactNode;
  characterCount?: number;
  maxCharacterLimit?: number;
  disable?: string
  
}

const FormField: React.FC<Props> = ({ label, badge, hint, children, characterCount, maxCharacterLimit }) => (
  <div className="cp-field">
    <div className="cp-field__label-row">
      <span className="cp-field__label">{label}</span>
      {badge && <span className="cp-field__badge">{badge}</span>}
    </div>
    {children}
    {characterCount !== undefined && maxCharacterLimit !== undefined && (<span style={{color:characterCount >= maxCharacterLimit ? '#ef4444':''}}> {characterCount}/{maxCharacterLimit} </span>)}
    {hint && <span className="cp-field__hint">{hint}</span>}
  </div>
);

export default FormField;